import axios from "axios";
import API_VERSION from "../data/api-version";

const transformArrayToObject = (arr) => {
  const entry = { rating_color: "#f546a8", testimonial_rating: 5, font_size: 1.0, speed: 50 }; // Default values if empty shopify metaobject

  for (const item of arr) {
    if (item.type === "date_time" || item.type === "color") {
      entry[item.key] = item.value;
      continue;
    }
    entry[item.key] = JSON.parse(item.value);
  }

  return entry;
};

const GetTopBannerData = async () => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          metaobjects(type:"customizer_top_banner", first:100){
            edges{
              node{
                id
                type
                fields{
                  key
                  type
                  value
                }
              }
            }
          }
        }`,
      },
    });

    const data = response?.data?.data?.metaobjects?.edges[0]?.node.fields || [];

    if (data?.length) {
      return transformArrayToObject(data);
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetTopBannerData;
